import React from "react";
import { Typography } from "antd";
import Icon from "@ant-design/icons";
import DefectRegister from "../../store/defectRegister";
import {
  DrainageSvg,
  ElectroSvg,
  LightSvg,
  TeploSvg,
  WaterSvg,
  WaterTwoSvg,
} from "../../assets/customIcons";
import "./index.scss";

const icons = {
  HeatSupply: TeploSvg,
  WaterSupply: WaterSvg,
  GasSupply: WaterTwoSvg,
  OutdoorLighting: LightSvg,
  WaterDrainage: DrainageSvg,
  PowerSupply: ElectroSvg,
};

const BadgeComponent = ({ title, icon, counts, gridTypeId }): JSX.Element => {
  const BadgeIco = (props) => <Icon component={icons[icon]} {...props} />;
  const [check, setCheck] = React.useState(true);

  const checkHandler = (e) => {
    if (!DefectRegister.initialFilter.gridTypeIds.includes(gridTypeId)) {
      DefectRegister.initialFilter.gridTypeIds.push(gridTypeId);

      setCheck(DefectRegister.initialFilter.gridTypeIds.includes(gridTypeId));
      DefectRegister.getRegistry();
    } else {
      for (
        let i = DefectRegister.initialFilter.gridTypeIds.length - 1;
        i >= 0;
        i--
      ) {
        if (DefectRegister.initialFilter.gridTypeIds[i] === gridTypeId) {
          DefectRegister.initialFilter.gridTypeIds.splice(i, 1);
        }
      }
      setCheck(DefectRegister.initialFilter.gridTypeIds.includes(gridTypeId));
      DefectRegister.getRegistry();
    }
    if (!DefectRegister.initialFilter.gridTypeIds.length) {
      DefectRegister.initialFilter.gridTypeIds = [];
    }

  };

  return (
    <button
      onClick={(e) => {
        checkHandler(e);
      }}
      className="badge-component"
    >
      <BadgeIco
        className={!check ? "badge-ico badge-ico--active" : "badge-ico"}
      />
      <p className={!check ? "badge-ico badge-ico--active" : "badge-ico"}>
        {title}
      </p>
      <div
        className={
          !check
            ? "badge-component__counts badge-ico badge-ico--active"
            : "badge-ico badge-component__counts"
        }
      >
        <span>{check ? counts.gray : 0}</span>
        <span>{check ? counts.red : 0}</span>
      </div>
    </button>
  );
};

export default BadgeComponent;
